// extracted by mini-css-extract-plugin
export var root = "yFKhmiq2x0hGQKNSfzdD";